module.exports = __webpack_public_path__ + "static/media/contactlensesColor.f102052b.pdf";